import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=8583b754&"
import script from "./HtmlEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports